import {
  GET_QUOTE_LIST,
  GET_QUOTE_LIST_SUCCESS,
  GET_QUOTE_LIST_FAILURE,
  GET_QUOTE_DETAILS,
  GET_QUOTE_DETAILS_SUCCESS,
  GET_QUOTE_DETAILS_FAILURE,
  CREATE_QUOTE,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILURE,
  UPDATE_QUOTE,
  UPDATE_QUOTE_SUCCESS,
  UPDATE_QUOTE_FAILURE,
  DELETE_QUOTE,
  DELETE_QUOTE_SUCCESS,
  DELETE_QUOTE_FAILURE,
  GET_QUOTE_STATUS_LIST,
  GET_QUOTE_STATUS_LIST_SUCCESS,
  GET_QUOTE_STATUS_LIST_FAILURE,
  GET_QUOTE_PDF,
  GET_QUOTE_PDF_SUCCESS,
  GET_QUOTE_PDF_FAILURE,
  ADD_NEW_QUOTE_STATUS,
  ADD_NEW_QUOTE_STATUS_SUCCESS,
  ADD_NEW_QUOTE_STATUS_FAILURE,
  UPDATE_QUOTE_STATUS,
  UPDATE_QUOTE_STATUS_SUCCESS,
  UPDATE_QUOTE_STATUS_FAILURE,
  DELETE_QUOTE_STATUS,
  DELETE_QUOTE_STATUS_SUCCESS,
  DELETE_QUOTE_STATUS_FAILURE,
  GET_SINGLE_CUSTOMER_QUOTE_LIST,
  GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE,
} from "./actionType";

// Action for Quote

// Get Quote List
export const getQuoteList = () => {
  return {
    type: GET_QUOTE_LIST,
  };
};

export const getQuoteListSuccess = (data) => {
  return {
    type: GET_QUOTE_LIST_SUCCESS,
    payload: data,
  };
};

export const getQuoteListFailure = (data) => {
  return {
    type: GET_QUOTE_LIST_FAILURE,
    payload: data,
  };
};

// Get Quote Details
export const getQuoteDetails = (data) => {
  return {
    type: GET_QUOTE_DETAILS,
    payload: data,
  };
};

export const getQuoteDetailsSuccess = (data) => {
  return {
    type: GET_QUOTE_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getQuoteDetailsFailure = (data) => {
  return {
    type: GET_QUOTE_DETAILS_FAILURE,
    payload: data,
  };
};

// Create Quote
export const createQuote = (data) => {
  return {
    type: CREATE_QUOTE,
    payload: data,
  };
};

export const createQuoteSuccess = (data) => {
  return {
    type: CREATE_QUOTE_SUCCESS,
    payload: data,
  };
};

export const createQuoteFailure = (data) => {
  return {
    type: CREATE_QUOTE_FAILURE,
    payload: data,
  };
};

// Update Quote
export const updateQuote = (data) => {
  return {
    type: UPDATE_QUOTE,
    payload: data,
  };
};

export const updateQuoteSuccess = (data) => {
  return {
    type: UPDATE_QUOTE_SUCCESS,
    payload: data,
  };
};

export const updateQuoteFailure = (data) => {
  return {
    type: UPDATE_QUOTE_FAILURE,
    payload: data,
  };
};

// Delete Quote
export const deleteQuote = (data) => {
  return {
    type: DELETE_QUOTE,
    payload: data,
  };
};

export const deleteQuoteSuccess = (data) => {
  return {
    type: DELETE_QUOTE_SUCCESS,
    payload: data,
  };
};

export const deleteQuoteFailure = (data) => {
  return {
    type: DELETE_QUOTE_FAILURE,
    payload: data,
  };
};

// Get Quote Status List
export const getQuoteStatusList = () => {
  return {
    type: GET_QUOTE_STATUS_LIST,
  };
};

export const getQuoteStatusListSuccess = (data) => {
  return {
    type: GET_QUOTE_STATUS_LIST_SUCCESS,
    payload: data,
  };
};

export const getQuoteStatusListFailure = (data) => {
  return {
    type: GET_QUOTE_STATUS_LIST_FAILURE,
    payload: data,
  };
};

// Get Quote PDF
export const getQuotePDF = (data) => {
  return {
    type: GET_QUOTE_PDF,
    payload: data,
  };
};

export const getQuotePDFSuccess = (data) => {
  return {
    type: GET_QUOTE_PDF_SUCCESS,
    payload: data,
  };
};

export const getQuotePDFFailure = (data) => {
  return {
    type: GET_QUOTE_PDF_FAILURE,
    payload: data,
  };
};

// add new quote status
export const addNewQuoteStatus = (data) => {
  return {
    type: ADD_NEW_QUOTE_STATUS,
    payload: data,
  };
};

export const addNewQuoteStatusSuccess = (data) => {
  return {
    type: ADD_NEW_QUOTE_STATUS_SUCCESS,
    payload: data,
  };
};

export const addNewQuoteStatusFailure = (data) => {
  return {
    type: ADD_NEW_QUOTE_STATUS_FAILURE,
    payload: data,
  };
};

// update quote status
export const updateQuoteStatus = (data) => {
  return {
    type: UPDATE_QUOTE_STATUS,
    payload: data,
  };
};

export const updateQuoteStatusSuccess = (data) => {
  return {
    type: UPDATE_QUOTE_STATUS_SUCCESS,
    payload: data,
  };
};

export const updateQuoteStatusFailure = (data) => {
  return {
    type: UPDATE_QUOTE_STATUS_FAILURE,
    payload: data,
  };
};

// delete quote status
export const deleteQuoteStatus = (data) => {
  return {
    type: DELETE_QUOTE_STATUS,
    payload: data,
  };
};

export const deleteQuoteStatusSuccess = (data) => {
  return {
    type: DELETE_QUOTE_STATUS_SUCCESS,
    payload: data,
  };
};

export const deleteQuoteStatusFailure = (data) => {
  return {
    type: DELETE_QUOTE_STATUS_FAILURE,
    payload: data,
  };
};

// single customer quote list
export const getSingleCustomerQuoteList = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_QUOTE_LIST,
    payload: data,
  };
};

export const getSingleCustomerQuoteListSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS,
    payload: data,
  };
};

export const getSingleCustomerQuoteListFailure = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE,
    payload: data,
  };
};
